import { fetchReferralSummary } from "../webService/webService";

/**
 * Referral wallet credit — earned KES 100 at a time when a friend you
 * referred completes their first order (see the Account > Refer & Earn
 * page). Auto-applied at checkout, same as the other two discounts.
 *
 * This is an optimistic preview for the checkout UI — the amount actually
 * charged is enforced server-side in mzito-pay (payment.controller.ts +
 * WalletService), which reads the balance directly rather than trusting
 * anything this module computes.
 */

/**
 * @param {string} token - Firebase ID token
 * @returns {Promise<number>} wallet balance in KES, 0 if unavailable
 */
export async function fetchWalletBalance(token) {
  if (!token) return 0;
  try {
    const summary = await fetchReferralSummary(token);
    return summary?.walletBalance ?? 0;
  } catch (error) {
    console.error("Error fetching wallet balance:", error);
    return 0;
  }
}

/**
 * @param {number} remainingAfterOtherDiscounts - subtotal + serviceFee + deliveryFee - other discounts
 * @param {number} walletBalance
 * @returns {{ credit: number }}
 */
export function applyWalletCredit(remainingAfterOtherDiscounts, walletBalance) {
  if (!(walletBalance > 0) || !(remainingAfterOtherDiscounts > 0)) {
    return { credit: 0 };
  }
  // Mirrors the server's KES-1 floor (payment.controller.ts) so the preview
  // never shows a fully-zeroed total that the real charge won't match.
  return { credit: Math.min(walletBalance, Math.max(0, remainingAfterOtherDiscounts - 1)) };
}
